// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__1D5Ic","title":"ClientInsurance_title__pXlGf","itemText":"ClientInsurance_itemText__u9V8X"};